export enum CardReissueReason {
    LOST = "L",
    DAMAGED = "D",
    STOLEN = "S",
}